import React from "react";
import PropTypes from "prop-types";

import "./SelectedChargingStationCard.scss";
import { FormattedMessage } from "react-intl";

import ChargingPinHigh from "./../../../client_customizations/assets/images/icons/High Power Stations.svg";
import ChargingPinPublic from "./../../../client_customizations/assets/images/icons/Public Stations.svg";
import ChargingPinPrivate from "./../../../client_customizations/assets/images/icons/Other Types of Stations.svg";

const SelectedChargingStationCard = ({ station }) => {
  if (!station) return null;

  let iconType = Number(station.ev_dc_fast_num)
    ? "highPower"
    : station.access_code === "public"
    ? "public"
    : "default";

  const {
    station_name: stationName,
    street_address: streetAddress,
    city,
    state,
    zip,
    station_phone: stationPhone,
    ev_network: evNetwork,
    ev_network_web: evNetworkWeb,
  } = station;

  const iconSrc = () => {
    switch (iconType) {
      case "public":
        return ChargingPinPublic;
      case "highPower":
        return ChargingPinHigh;
      case "private":
      default:
        return ChargingPinPrivate;
    }
  };

  return (
    <div className="SelectedChargingStationCard">
      <div className="topContainer">
        <img alt="icon for charging station map" src={iconSrc(iconType)} />
        <p>{stationName}</p>
      </div>
      <br />
      {streetAddress}
      <br />
      {`${city}, ${state} ${zip}`}
      <br />
      {stationPhone}
      <br />
      {evNetwork && evNetworkWeb && (
        <a href={evNetworkWeb} target="_blank" rel="noopener noreferrer">
          {evNetwork}
        </a>
      )}
      {(!evNetwork || !evNetworkWeb) && (
        <em>
          <FormattedMessage
            id="linkUnavailable"
            defaultMessage="Link to Network Unavailable"
            description="Link to Network Unavailable"
          />
        </em>
      )}
    </div>
  );
};

export default SelectedChargingStationCard;

SelectedChargingStationCard.propTypes = {
  station: PropTypes.object,
};
